import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {PLAYERS_ROUTE, PLAYERS_ROUTE_NEW} from '../http-routes';
import {IDefaultResponse, IDefaultResponseT} from '@api/models/default-response/response';
import {IPlayer} from '@api/models/player/player';
import {IPlayerRequest} from '@api/models/player/player-request';

@Injectable({
  providedIn: 'root'
})
export class PlayersHttpService {

  constructor(private http: HttpService) { }

  public async postPlayer(player: IPlayerRequest): Promise<IDefaultResponseT<IPlayer>> {
    return this.http.post<IDefaultResponseT<IPlayer>>([PLAYERS_ROUTE], player).toPromise();
  }

  public async putPlayer(playerId: string, player: IPlayerRequest): Promise<IDefaultResponseT<IPlayer>> {
    return this.http.put<IDefaultResponseT<IPlayer>>([PLAYERS_ROUTE, playerId], player).toPromise();
  }

  public async getPlayer(playerId: string): Promise<IPlayer> {
    return this.http.get<IPlayer>([PLAYERS_ROUTE, playerId]);
  }

  public async deletePlayer(playerId: string, teamId: string): Promise<IDefaultResponse> {
    return this.http.delete([PLAYERS_ROUTE, playerId], [], { teamid: teamId }).toPromise();
  }

  public async mergePlayers(teamId: string, replacePlayerId: string,
                            keepPlayerId: string): Promise<IDefaultResponse> {
    return this.http.put<IDefaultResponse>(
      [PLAYERS_ROUTE_NEW, 'merge', 'team', teamId, replacePlayerId, keepPlayerId]).toPromise();
  }

  public async putPlayerSkillsLabScore(playerId: string, score: number): Promise<IDefaultResponseT<IPlayer>> {
    return this.http.patch<IDefaultResponseT<IPlayer>>(
      [PLAYERS_ROUTE_NEW, 'skills-lab', playerId], { score }).toPromise();
  }
}
